module.exports = __webpack_public_path__ + "assets/img/farley_mowat-188ac742.jpg";